import { BAFTA_FUND_SLUG, User } from "@ecologi/shared";
import styled from "@emotion/styled";
import { useRouter } from "next/router";
import { Button } from "../../Button";
import { TuftyButton } from "../../Button/TuftyButton";

type Props = {
  setAlbertModalState: (state: boolean) => void;
  isOwnProfile: boolean;
  isBulkParent?: boolean;
  user?: User | null;
  isNewBaftaExperienceEnabled?: boolean;
};

export const BespokeBaftaAlbertWrapper = styled.div`
  display: block;
  margin-top: 24px;
`;

export const BespokeNetZeroSessionsWrapper = styled.div`
  display: block;
  margin: 15px auto 0;
`;

export const BuyMoreImpactButton = ({
  setAlbertModalState,
  isOwnProfile,
  isBulkParent,
  isNewBaftaExperienceEnabled = false,
}: Props) => {
  const router = useRouter();

  if (isOwnProfile && isBulkParent && !isNewBaftaExperienceEnabled) {
    return (
      <BespokeBaftaAlbertWrapper>
        <Button
          primary
          text="Request Impact"
          onClick={() => {
            setAlbertModalState(true);
          }}
        />
      </BespokeBaftaAlbertWrapper>
    );
  }

  return (
    <TuftyButton
      primary
      extra={{
        style: {
          display: "block",
          margin: "15px auto 0",
        },
      }}
      onClick={(e) => {
        e.preventDefault();
        if (e.currentTarget instanceof HTMLElement) {
          e.currentTarget.blur();
        }

        if (isOwnProfile && isNewBaftaExperienceEnabled && isBulkParent) {
          router.push(`/impact-shop/${BAFTA_FUND_SLUG}`);
          return;
        }
        router.push("/impact-shop");
      }}
      text={isOwnProfile ? "Buy more impact" : "Fund impact"}
    />
  );
};
